const messages = {
  title: "Consentements Marketing",
  required: "Requis",
  answered: "✓ Répondu",
  read: "Lu",
  notRead: "Non lu",
  alreadyAnswered: "Déjà répondu",
  requiredQuestionsMustBeAccepted: "{count} question{plural} requise{plural} doit{plural} être acceptée{plural}",
  pleaseAnswerQuestions: "Veuillez répondre aux questions suivantes :",
  iAccept: "J'accepte",
  scrollToUnlock: "Faites défiler jusqu'en bas pour déverrouiller",
  fieldRequired: "Ce champ est obligatoire",
  scrollToContinue: "↓ Faites défiler jusqu'en bas pour continuer",
  saving: "Enregistrement...",
  saveConsents: "Enregistrer les consentements",
  allRequiredAccepted: "✓ Toutes les questions requises acceptées",
  requiredConsentsCompleted: "{completed}/{total} consentements requis complétés",
  selectConsentToView: "Sélectionnez un consentement dans la liste pour voir son contenu",
  readAllContentFirst: "Lisez tout le contenu d'abord : {names}",
  acceptAllRequiredIn: "Acceptez toutes les questions requises dans : {names}",
  acceptAllBeforeSaving: "Veuillez accepter toutes les questions requises avant d'enregistrer.",
  failedToSave: "Échec de l'enregistrement des consentements. Veuillez réessayer.",
  errorSaving: "Une erreur s'est produite lors de l'enregistrement des consentements. Veuillez réessayer.",
  failedToLoad: "Échec du chargement des consentements. Veuillez actualiser la page.",
  viewPdf: "Voir le PDF",
  requiredConsentTitle: "Consentement requis",
  acceptAndContinue: "Accepter et continuer",
};

export default {
  messages,
};
